import React from "react";
import Modal from "react-bootstrap/Modal";
import Avatar from "../../../../../../assets/images/avatarr.png";
import "./index.css";
import Phone from "../../../../../../assets/images/phone.png";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import capitalize from "../../../../../../capitalize";

const HistoryModal = ({ showDrop, handleCloseDrop, loading, modalInfo }) => {
  const details = JSON.parse(localStorage.getItem("detailsDropOffss"));
  // console.log(modalInfo);
  return (
    <div>
      <Modal
        show={showDrop}
        onHide={handleCloseDrop}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="card_inners_amount my-4 text-center">
              <span>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </span>
            </div>
          ) : (
            <div className="text-left ml-3">
              <div className="mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="">
                      <p
                        className="mb-0"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        {modalInfo?.center?.name}
                      </p>
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#898989",
                        }}
                      >
                        {modalInfo?.center?.address}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mr-5">
                    <div className="form-group">
                      <div className="mr-5">
                        <p
                          className="mb-0 ml-2"
                          style={{ fontSize: "13px", color: "#898989" }}
                        >
                          Date Registered
                        </p>
                        <p
                          className="ml-2"
                          style={{
                            fontSize: "14px",
                            color: "#404040",
                            fontWeight: "700",
                          }}
                        >
                          {moment(modalInfo?.created_at).format("DD/MM/YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="d-flex justify-content-between align-items-center items-center pt-2">
                    <div>
                      <div className="d-flex">
                        <div
                          style={{
                            padding: "7px 10px",
                            backgroundColor: "#404040",
                            color: "#c4da00",
                            borderRadius: "50px",
                            height: "fit-content",
                          }}
                        >
                          <p className="mb-0">
                            {capitalize(modalInfo?.status)}
                          </p>
                        </div>

                        <div>
                          <div className="form-group">
                            <div className="ml-3">
                              <p
                                className="mb-0 ml-2"
                                style={{ fontSize: "13px", color: "#898989" }}
                              >
                                Evacuation Code
                              </p>
                              <p
                                className="ml-2"
                                style={{
                                  fontSize: "14px",
                                  color: "#404040",
                                  fontWeight: "700",
                                }}
                              >
                                {modalInfo?.code}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex mr-3">
                      <div className="form-group">
                        <div className="mr-3">
                          <p
                            className="mb-0 ml-2"
                            style={{ fontSize: "13px", color: "#898989" }}
                          >
                            Date Completed
                          </p>
                          <p
                            className="ml-2"
                            style={{
                              fontSize: "14px",
                              color: "#404040",
                              fontWeight: "700",
                            }}
                          >
                            {moment(modalInfo?.evacuated_at).format("DD/MM/YYYY")}
                          </p>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="d-flex">
                          <div>
                            <p
                              className="mb-0 ml-0"
                              style={{ fontSize: "13px", color: "#898989" }}
                            >
                              Time
                            </p>
                            <p
                              className="ml-0"
                              style={{
                                fontSize: "14px",
                                color: "#404040",
                                fontWeight: "700",
                              }}
                            >
                              {moment(modalInfo?.evacuated_at, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="d-flex justify-content-between pt-2">
                    <div>
                      <div className="d-flex align-items-center items-center">
                        <p
                          className="mb-0 mr-4"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          Total Center Weight
                        </p>
                        <p
                          className="ml-0 mb-0"
                          style={{
                            fontSize: "14px",
                            color: "#404040",
                            fontWeight: "600",
                          }}
                        >
                          {`${modalInfo?.total_requested_kg}kg`}
                        </p>
                      </div>

                      <div className="d-flex align-items-center items-center mt-2">
                        <p
                          className="mb-0 mr-4"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          Total Recyclables
                        </p>
                        <p
                          className="ml-0 mb-0"
                          style={{
                            fontSize: "14px",
                            color: "#404040",
                            fontWeight: "600",
                          }}
                        >
                          {`${modalInfo?.total_evacuated_kg}kg`}
                        </p>
                      </div>

                      <div className="d-flex align-items-center items-center mt-2">
                        <p
                          className="mb-0 mr-4"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          Difference
                        </p>
                        <p
                          className="ml-0 mb-0"
                          style={{
                            fontSize: "14px",
                            color: "#404040",
                            fontWeight: "600",
                          }}
                        >
                          {`${modalInfo?.difference_kg}kg`}
                        </p>
                      </div>

                      {/* The products this evacuation was actually raised
                          against, with what was declared beside what arrived.
                          The pet_plastic/nylon roll-up printed here before
                          could not name a product, and read 0kg for CAN and
                          Aluminum, which have no legacy bucket at all. */}
                      <div className="mt-4">
                        {Array.isArray(modalInfo?.evacuation_groups) &&
                        modalInfo.evacuation_groups.length ? (
                          modalInfo.evacuation_groups.map((group) => (
                            <div
                              className="d-flex align-items-center items-center mt-2"
                              key={group.label}
                            >
                              <p
                                className="mb-0 mr-2"
                                style={{ fontSize: "13px", color: "#000000" }}
                              >
                                {`${group.name || group.label}:`}
                              </p>
                              <p
                                className="ml-0 mb-0"
                                style={{
                                  fontSize: "14px",
                                  color: "#404040",
                                  fontWeight: "400",
                                }}
                              >
                                {group.evacuated_kg === null ||
                                group.evacuated_kg === undefined
                                  ? `${Number(group.requested_kg) || 0}kg requested`
                                  : `${Number(group.evacuated_kg) || 0}kg of ${
                                      Number(group.requested_kg) || 0
                                    }kg declared`}
                              </p>
                            </div>
                          ))
                        ) : (
                          <>
                        <div className="d-flex align-items-center items-center">
                          <p
                            className="mb-0 mr-2"
                            style={{ fontSize: "13px", color: "#000000" }}
                          >
                            PET Plastics ~ Center:
                          </p>
                          <p
                            className="ml-0 mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#404040",
                              fontWeight: "400",
                            }}
                          >
                            {`${modalInfo?.evacuated_pet_plastic_kg}kg`}
                          </p>
                        </div>
                        <div className="d-flex align-items-center items-center mt-2">
                          <p
                            className="mb-0 mr-2"
                            style={{ fontSize: "13px", color: "#000000" }}
                          >
                            Nylon ~ Center:
                          </p>
                          <p
                            className="ml-0 mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#404040",
                              fontWeight: "400",
                            }}
                          >
                            {`${modalInfo?.evacuated_nylon_kg}kg`}
                          </p>
                        </div>
                          </>
                        )}
                      </div>

                      {/* <div className="mt-4">
                        <div className="d-flex align-items-center items-center">
                          <p
                            className="mb-0 mr-2"
                            style={{ fontSize: "13px", color: "#000000" }}
                          >
                            PET Plastics ~ Factory:
                          </p>
                          <p
                            className="ml-0 mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#404040",
                              fontWeight: "400",
                            }}
                          >
                            1,094.00kg
                          </p>
                        </div>
                        <div className="d-flex align-items-center items-center mt-2">
                          <p
                            className="mb-0 mr-2"
                            style={{ fontSize: "13px", color: "#000000" }}
                          >
                            Nylon ~ Factory:
                          </p>
                          <p
                            className="ml-0 mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#404040",
                              fontWeight: "400",
                            }}
                          >
                            4.00kg
                          </p>
                        </div>
                      </div> */}

                      <div className="mt-3">
                        <p
                          className="mb-0 mr-2"
                          style={{
                            fontSize: "13px",
                            color: "#000000",
                            fontWeight: "600",
                          }}
                        >
                          {modalInfo?.switch_center}
                        </p>
                        <div className="d-flex align-items-center items-center mt-2">
                          <p
                            className="mb-0 mr-2"
                            style={{ fontSize: "13px", color: "#000000" }}
                          >
                            Status:
                          </p>
                          <p
                            className="ml-0 mb-0"
                            style={{
                              fontSize: "14px",
                              color: "#404040",
                              fontWeight: "400",
                            }}
                          >
                            {capitalize(modalInfo?.status)}
                          </p>
                        </div>
                        {/* <div className="mt-2">
                          <p
                            className="mb-0 mr-2"
                            style={{ fontSize: "13px", color: "#898989" }}
                          >
                            Completion Time
                          </p>
                          <p
                            className="mb-0 mr-2"
                            style={{
                              fontSize: "13px",
                              color: "#000000",
                              fontWeight: "600",
                            }}
                          >
                            3hrs 20mins
                          </p>
                        </div> */}
                      </div>
                    </div>
                    <div className="align-self-start mr-4">
                      <div className="d-flex align-items-center">
                        <img src={Phone} alt="phone" />
                        <p
                          className="mb-0 ml-2"
                          style={{ fontSize: "14px", color: "#898989" }}
                        >
                          {modalInfo?.center?.phone}
                        </p>
                      </div>
                      <div className="mt-4">
                        <p
                          className="mb-0 mr-2"
                          style={{
                            fontSize: "13px",
                            color: "#000000",
                            fontWeight: "600",
                          }}
                        >
                          3rd Party Driver Details
                        </p>
                      </div>
                      <div className="d-flex align-items-center mt-2">
                        <img src={Avatar} alt="avatar" />
                        <p
                          className="mb-0 ml-2"
                          style={{ fontSize: "14px", color: "#000" }}
                        >
                          {modalInfo?.driver_name}
                        </p>
                      </div>
                      <div className="d-flex align-items-center mt-4">
                        <img src={Phone} alt="phone" />
                        <p
                          className="mb-0 ml-2"
                          style={{ fontSize: "14px", color: "#898989" }}
                        >
                          {modalInfo?.driver_phone}
                        </p>
                      </div>

                      <div className="mt-4">
                        <p
                          className="mb-0 mr-2"
                          style={{ fontSize: "13px", color: "#000" }}
                        >
                          Vehicle No:
                        </p>
                        <p
                          className="mb-0 mr-2"
                          style={{
                            fontSize: "13px",
                            color: "#000000",
                            fontWeight: "400",
                          }}
                        >
                          {modalInfo?.vehicle_plate_no}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HistoryModal;
